import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';

import messages from '../../messages';

const rejectFile = async ({
  type,
  userUuid,
  fileUuid,
  params,
}: {
  type: string;
  userUuid: string;
  fileUuid: string;
  params: Record<string, string | object>;
}) => {
  let payload:
    | { asset: Record<string, string | object> }
    | { user_language: Record<string, string | object> } = {
    asset: { ...params },
  };

  if (type.includes('languages')) {
    payload = {
      user_language: { ...params },
    };
  }

  let url = `candidates/${userUuid}/${type}/${fileUuid}`;

  if (type === 'cancellation_proofs') {
    url = `${type}/${fileUuid}`;
  }

  if (type === 'without_proof') {
    url = `cancellation_notices/${fileUuid}`;
  }

  if (type.includes('languages')) {
    url = `candidates/${userUuid}/${type}`;
  }

  const res = await putRequest(API.PUT.rejectVerificationFile(url), payload);
  return res.data;
};

export const useUpdateRejectVerificationFile = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: rejectFile,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.VERIFICATION_FILES],
      });
      handleSuccess(formatMessage(messages.declineDone));
    },
    onError: handleError,
  });
};
